const config = {
  zipkin: {
    url: 'http://zipkin.pre.tyc.io/',
    samplerRatio: 1,
  },
  fetchConfig: {
    capiServer: 'https://capisss.tianyancha.com',
    napiServer: 'https://napi-huawei-pre.tianyancha.com',
    gapiServer: 'https://cloud-gateway-pre.tianyancha.com',
  },
  serverDomain: 'https://www-pre.tianyancha.com',
  qifuServerDomain: 'https://www.tianyanqifu.com',
  newsServerDomain: 'https://news-pew.tianyancha.com',
  discussServerDomain: 'https://discuss-pre.tianyancha.com',
  cookieServerSuffix: '.tianyancha.com',
  tokerServerDomain: 'https://sj-pre.tianyancha.com',
  ownServerDomain: 'https://www-pre.tianyancha.com',

  ssrOriginCapi: 'http://cloud-gateway-pre.services.huawei',
  ssrOriginNapi: 'http://inner-napi-pre.services.huawei',
  ssrOriginNode: 'http://inner-napi-pre.services.huawei', // TODO 下线，使用 napi
};

module.exports = config;
